import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Task } from "@common/types/task";
import { useUpdateTask } from "@api/task.api";
import { memo } from "react";
import { useSortedCloseStages } from "@api/organizationCloseStage.api";
import { useScope } from "@state/scopeContext.lib";
import { NestedTaskRow } from "../../types";
import { CloseSelectCell } from "./CloseSelectCell";

export const CloseStageCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        NestedTaskRow,
        Task["closeStageId"] | null
    >) => {
        const task = row.original as Task;
        const updateTask = useUpdateTask(task);
        const sortedCloseStages = useSortedCloseStages();
        const { organizationId } = useScope();

        if (
            row.original.isGroup ||
            row.original.isNewPlaceholder ||
            !organizationId ||
            sortedCloseStages.length === 0
        ) {
            return null;
        }

        return (
            <CloseSelectCell
                value={task.closeStageId ?? null}
                items={sortedCloseStages}
                addText="Add stage"
                nullLabel="No stage"
                onValueChange={(value) =>
                    updateTask.mutate({ closeStageId: value })
                }
            />
        );
    },
);
